<template>
    <BaseWidget :title="widget.title">
        <div>
            <apexchart
                :type="widget.content.chartData.chart.type"
                :height="150"
                :series="widget.content.chartData.series"
                :options="widget.content.chartData"
            >
            </apexchart>
        </div>

        <div class="inline-block flex px-4 py-2 text-sm leading-5 truncate space-x-2 w-full">
            <div v-if="widget.content.gamificationScoreCard.current_level !== null">
                <Tippy>
                    <button>
                        <BadgePill>
                            {{ widget.content.gamificationScoreCard.current_level }}
                        </BadgePill>
                    </button>
                    <template #content>
                        {{ $tc('messages.levels', 1) }}
                    </template>
                </Tippy>
            </div>
            <div class="w-full">
                <ProgressBar :percent="widget.content.gamificationScoreCard.percent">
                    <span v-if="true"
                        >{{ widget.content.gamificationScoreCard.current_level_experience_points }} /
                        {{ widget.content.gamificationScoreCard.width }}</span
                    >
                    ({{ widget.content.gamificationScoreCard.percent }}%)
                </ProgressBar>
                <ProgressBar
                    v-if="widget.content.gamificationScoreCard.health_percent"
                    :percent="widget.content.gamificationScoreCard.health_percent"
                    color="red"
                    height="sm"
                    class="mt-1"
                >
                </ProgressBar>
                <ProgressBarCurrentMax
                    v-if="widget.content.card_settings.use_health"
                    :current="widget.content.gamificationScoreCard.health_total"
                    :min="0"
                    :max="widget.content.gamificationScoreCard.health_max"
                    :title="`${widget.content.gamificationScoreCard.health_total}/${widget.content.gamificationScoreCard.health_max}`"
                    color="red"
                    height="sm"
                    class="mt-1"
                >
                    &nbsp;
                </ProgressBarCurrentMax>
                <ProgressBarCurrentMax
                    v-if="widget.content.card_settings.use_energy"
                    :current="widget.content.gamificationScoreCard.energy_total"
                    :min="0"
                    :max="widget.content.card_settings.max_energy"
                    :title="`${widget.content.gamificationScoreCard.energy_total}/${widget.content.card_settings.max_energy}`"
                    color="blue"
                    height="sm"
                    class="mt-1"
                >
                    &nbsp;
                </ProgressBarCurrentMax>
            </div>
            <div>
                <BadgePill color="yellow">
                    {{ widget.content.gamificationScoreCard.coins_total }}
                </BadgePill>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import BadgePill from '@/components/BadgePill.vue';
import ProgressBar from '@/components/Gamification/ProgressBar.vue';
import { Tippy } from 'vue-tippy';
import ProgressBarCurrentMax from '../../Gamification/ProgressBarCurrentMax.vue';

export default {
    name: 'GamificationCardWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        ProgressBarCurrentMax,
        BaseWidget,
        BadgePill,
        ProgressBar,
        Tippy,
    },
};
</script>
